import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { TopicListEffects } from './topic-list.effects';
import { initialState, reducer } from './topic-list.reducer';
import { createWorkspaceScopedSyncReducer } from '../local-storage-sync';
import { TopicListState } from './topic-list.state';

const syncMetaReducer = createWorkspaceScopedSyncReducer<TopicListState>({
  keys: ['collapsedTopics'],
  rehydrate: true,
  storage: localStorage,
});

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('topicList', reducer, { initialState, metaReducers: [syncMetaReducer] }),
    EffectsModule.forFeature([TopicListEffects]),
  ],
  providers: [TopicListEffects],
})
export class TopicListStoreModule {}
